import React from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';

export default function({ onClick }) {
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const user = useSelector(state => state.AppState.user);
  const getActivateButtonText = () => {
    if (!boxDetails) return '';
    const { registered, registerationCreated,apiOnline } = boxDetails;
    if (registered && registerationCreated && apiOnline ) return 'Edge Device Activated';
    if (!registered && registerationCreated && !apiOnline) return 'Pending Activation';
    return 'Activate box';
  };
  const getColor = () => {
    const { registered, registerationCreated ,apiOnline} = boxDetails;
    if (registered && registerationCreated && apiOnline) return 'success';
    return 'primary';
  };
  const getIsDisabled = () => {
    const { registered, registerationCreated } = boxDetails;
    if (registered && registerationCreated && user.role !== 'superAdmin') return true;
    return false;
  };
  const onButtonPress = () => {
    const { datacenter } = boxDetails;
    if (datacenter != 'la') {
      return toast.success('Please move to LA Data Center to enable this feature.');
    }
    onClick();
  };
  return (
    <Button
      className="activate-btn"
      disabled={getIsDisabled()}
      color={getColor()}
      onClick={onButtonPress}
    >
      {getActivateButtonText()}
    </Button>
  );
}
